/** @format */

export default {
  methods: {
    getFieldCustomRules(propertyName) {
      const { code: countryCode } = this.$store.state.app.country;
      const { customFieldsRules } = this.$store.state.partner;

      if (customFieldsRules) {
        if (
          customFieldsRules[countryCode] &&
          customFieldsRules[countryCode][propertyName]
        ) {
          return customFieldsRules[countryCode][propertyName];
        }
      }

      return false;
    },
    isValidLength(value, propertyName) {
      if (!value) return false;

      const customFieldRules = this.getFieldCustomRules(propertyName);
      if (customFieldRules) {
        const { minLength, maxLength } = customFieldRules;
        if (minLength && value.length < minLength) return false;
        if (maxLength && value.length > maxLength) return false;
      }
      return true;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/customFieldsRules.js